import styled from "styled-components";

export const PaginationContainer = styled.div`
  display: block;
  justify-content: start;
  width: 100%;
  padding: 15px 0;
`

export const PaginationItem = styled.span<{ active?: boolean }>`
  padding: 6px 8px;
  margin-right: 6px;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 500;
  border: 1px solid ${({ active }) => active ? "#0e2b45" : "#ddd"};
  border-radius: 4px;
  color: ${({ active }) => active ? "#fff" : "#0e2b45"};
  background: ${({ active }) => active ? "#0e2b45" : "#fff"};
  cursor: ${({ active }) => active ? "default" : "pointer"};
  text-transform: uppercase;
  user-select: none;
  transition: all 200ms ease;

  &:hover {
    color: #fff;
    background: #0e2b45;
    border-color: #0e2b45;
  }
`
